import { createContext, useState, useEffect } from "react";

import {db} from '../firebase';
import {collection, getDocs} from 'firebase/firestore';
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import {auth} from '../firebase';

export const UserContext = createContext()

export function UserContextProvider(props) {


  // LOADER CUSTOM
  
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    },1000);
  }, [])

  
  
  // // state user
  const [currentUser, setCurrentUser] = useState()
  const [loadingDatas, setLoadingDatas] = useState(true);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setCurrentUser(currentUser);
      setLoadingDatas(false);
    })
    return unsubscribe;
  }, [])


              //DATAS

  const [realDatas, setRealDatas] = useState([]);
  const [mangaDatas, setMangaDatas] = useState([]);
  const [japDatas, setJapDatas] = useState([]);
  const [autresDatas, setAutresDatas] = useState([]);
  const [dessinsDatas, setDessinsDatas] = useState([]);

 
  const realCollectionRef = collection(db, "real"); 
  const mangaCollectionRef = collection(db, "manga");
  const japCollectionRef = collection(db, "jap");
  const autresCollectionRef = collection(db, "autres");
  const dessinsCollectionRef = collection(db, "draw");
 

  //REAL DATAS
  useEffect(() => {
    const getRealData= async () => {
      const datas = await getDocs(realCollectionRef);
      // console.log(datas)
      setRealDatas(datas.docs.map((doc) => ({ ...doc.data(), id:doc.id})));
    }
    
    getRealData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );


  // MANGA DATAS
  useEffect(() => {
    const getMangaData= async () => {
      const datas = await getDocs(mangaCollectionRef);
      // console.log(datas)
      setMangaDatas(datas.docs.map((doc) => ({ ...doc.data(), id:doc.id})));
    }
    
    getMangaData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );


  // JAP DATAS
  useEffect(() => {
    const getJapData= async () => {
      const datas = await getDocs(japCollectionRef);
      // console.log(datas)
      setJapDatas(datas.docs.map((doc) => ({ ...doc.data(), id:doc.id})));
    }
    
    getJapData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );


   // AUTRES DATAS
   useEffect(() => {
    const getAutresData= async () => {
      const datas = await getDocs(autresCollectionRef);
      // console.log(datas)
      setAutresDatas(datas.docs.map((doc) => ({ ...doc.data(), id:doc.id})));
    }
    
    getAutresData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );


    // DESSINS DATAS
    useEffect(() => {
      const getDessinsData= async () => {
        const datas = await getDocs(dessinsCollectionRef);
        // console.log(datas)
        setDessinsDatas(datas.docs.map((doc) => ({ ...doc.data(), id:doc.id})));
      }
      
      getDessinsData();
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );



          // AUTHENTIFICATION


    const signIn = (email, password) => {
      signInWithEmailAndPassword(auth, email, password)
    }
  


  return(
    <UserContext.Provider value={
      {
      
        loader,
        mangaDatas,
        japDatas,
        autresDatas,
        realDatas,
        dessinsDatas,
        signIn,
        currentUser
      
      }}>

      {!loadingDatas && props.children}
    </UserContext.Provider>
  )
}

